// extracted by mini-css-extract-plugin
module.exports = {"radio":"RadioCard_radio__2TEBD","label":"RadioCard_label__3MdqC","body":"RadioCard_body__H_2qh","icon":"RadioCard_icon__M_A7p"};